const initialBranchValues = {
  Name: "",
  Address: {
    Street: "",
    Additional: "",
    City: "",
    Zip: "",
    CountryCode: "",
  },
  Coordinate: {
    Latitude: 53.2734,
    Longitude: -7.77832031,
  },
  Timezone: undefined,
  Calendar: {
    Daysinfo: {
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
      Saturday: [],
      Sunday: [],
    },
  },
  Contact: {
    Emails: undefined,
    Phones: ["961","961"],
    Website: "",
  },
  Services: [{ Service: "", Active: true }],
};

export default initialBranchValues;
